import React from "react";
import "../assets/css/Footer.css";
import logo from '../assets/am-logo/am-logo.png';

export default function Footer() {
    return (
        <footer className="am-footer">
            <div className="am-footer-container">

                {/* BRAND */}
                <div className="am-footer-brand">
                    <h2 className="am-footer-logo"><img src={logo}></img></h2>
                    <p className="am-footer-tagline">
                        One App. One Mentor. Complete Academic Journey.
                    </p>
                </div>

                {/* QUICK LINKS */}
                <div className="am-footer-links">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="#">Home</a></li>
                        <li><a href="#about">About Us</a></li>
                        {/* <li><a href="#">How Admission Works</a></li> */}
                        <li><a href="#faq">FAQ</a></li>
                        <li><a href="#register">Franchise</a></li>
                    </ul>
                </div>

                {/* FOR STUDENTS */}
                <div className="am-footer-links">
                    <h4>For Students</h4>
                    <ul>
                        <li><a href="#">Classes 8th–10th</a></li>
                        <li><a href="#">SSC / CBSE / ICSE</a></li>
                        <li><a href="#">Aabhyasika Network</a></li>
                        <li><a href="#">Download App</a></li>
                    </ul>
                </div>

                {/* CONTACT */}
                <div className="am-footer-contact">
                    <h4>Contact Us</h4>
                    <p> Pune Maharashtra, India</p>
                    <p>+91 97306 10099 / 95033 70099</p>
                    <p>✉️ support@aabhyasmitra.com</p>
                </div>
            </div>

            {/* BOTTOM */}
            <div className="am-footer-bottom">
                <p>
                    © {new Date().getFullYear()} Aabhyas Mitra. All rights reserved.
                </p>
                <div className="am-footer-bottom-links">
                    <a href="#">Privacy Policy</a>
                    <a href="#">Terms & Conditions</a>
                </div>
            </div>
        </footer>
    );
}
